import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { TwoFactorOperationCode } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { Phones } from '@app/entities/models/ptrab/shared/phone.model';
import { TwoFactor } from '@app/entities/models/ptrab/two-factor/two-factor.model';

export interface TwoFactorRepository {
  getPhoneList(): Observable<Phones>;
  sendValidationCodeToPhone(operation: TwoFactorOperationCode, phone: string): Observable<TwoFactor>;
  validateCode(operation: TwoFactorOperationCode, code: string, phone?: string): Observable<string>;
  getUserStatus(): Observable<any>;
}

export const TWO_FACTOR_REPOSITORY = new InjectionToken<TwoFactorRepository>('TWO_FACTOR_REPOSITORY');
